module.exports = __webpack_public_path__ + "img/9788958289227.1b4c09fb.jpg";